import styled from 'styled-components';
import { loaderImage } from '@mews-commander/assets';
import { TooltippedSpan } from '@mews-commander/ui';

const LoadingAction = () => (
    <TooltippedSpan tooltip="Loading">
        <StyledLoader src={loaderImage} alt="Loading" />
    </TooltippedSpan>
);

const StyledLoader = styled.img`
    height: 24px;
    width: 24px;
`;

export default LoadingAction;
